import React from "react";
import { Row, Col } from "react-bootstrap";
import { LuPlusSquare, LuCalendar, LuTag, LuStore } from "react-icons/lu";
import { QuickActionsProps } from "../types";

const QuickActions: React.FC<QuickActionsProps> = ({
  onAddProduct,
  onViewProducts,
  onCreateOffer,
  onEditStorePage,
}) => {
  return (
    <div className="bg-white rounded-4 border border-1 border-light-subtle p-4 shadow-sm flex-grow-1">
      <h5 className="fw-bold text-dark mb-3 fs-6">Quick actions</h5>
      <Row className="g-3">
        <Col sm={6}>
          <button
            type="button"
            className="btn w-100 p-3 rounded-4 border-0 d-flex flex-column align-items-center justify-content-center gap-2 text-center text-dark h-100 shadow-none"
            style={{
              backgroundColor: "#EFF6FF",
              transition: "all 0.2s ease",
            }}
            onClick={onAddProduct}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center text-white shadow-sm"
              style={{
                width: 44,
                height: 44,
                backgroundColor: "#2563EB",
              }}
            >
              <LuPlusSquare size={22} />
            </div>
            <span className="fw-semibold small">Add product</span>
          </button>
        </Col>
        <Col sm={6}>
          <button
            type="button"
            className="btn w-100 p-3 rounded-4 border-0 d-flex flex-column align-items-center justify-content-center gap-2 text-center text-dark h-100 shadow-none"
            style={{
              backgroundColor: "#EFF6FF",
              transition: "all 0.2s ease",
            }}
            onClick={onViewProducts}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center text-white shadow-sm"
              style={{
                width: 44,
                height: 44,
                backgroundColor: "#3B82F6",
              }}
            >
              <LuCalendar size={22} />
            </div>
            <span className="fw-semibold small">View Products</span>
          </button>
        </Col>
        <Col sm={6}>
          <button
            type="button"
            className="btn w-100 p-3 rounded-4 border-0 d-flex flex-column align-items-center justify-content-center gap-2 text-center text-dark h-100 shadow-none"
            style={{
              backgroundColor: "#FFF7ED",
              transition: "all 0.2s ease",
            }}
            onClick={onCreateOffer}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center text-white shadow-sm"
              style={{
                width: 44,
                height: 44,
                backgroundColor: "#F97316",
              }}
            >
              <LuTag size={22} />
            </div>
            <span className="fw-semibold small">Create offer</span>
          </button>
        </Col>
        <Col sm={6}>
          <button
            type="button"
            className="btn w-100 p-3 rounded-4 border-0 d-flex flex-column align-items-center justify-content-center gap-2 text-center text-dark h-100 shadow-none"
            style={{
              backgroundColor: "#F0FDF4",
              transition: "all 0.2s ease",
            }}
            onClick={onEditStorePage}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center text-white shadow-sm"
              style={{
                width: 44,
                height: 44,
                backgroundColor: "#16A34A",
              }}
            >
              <LuStore size={22} />
            </div>
            <span className="fw-semibold small">Edit store page</span>
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(QuickActions);

